import { Component, Input } from '@angular/core'

@Component({
    selector: 'mg-ui-card',
    templateUrl: './ui-card.component.html',
    styleUrls: ['./ui-card.component.scss'],
})
export class UiCardComponent {
    @Input() hasGutter: boolean = true
    @Input() hasBody: boolean = true
    @Input() title: string = ''
    @Input() subtitle: string = ''
    @Input() subtitleLink: string = ''
    @Input() subtitleLinkLabel: string = ''
    @Input() icon: string = ''
}
